import { StatusAnalise } from "./enums/status-candidatura-enum";
import { Ufs } from "./enums/uf-enum";

export class Aprovacao  {

    constructor(
        public id?: number,
        public preCandidatoId?: any,
        public aprovadorId?: any,
        public statusAnalise?: StatusAnalise,
        public justificativaIndeferimento?: string,
        public observacao?: string,      
    ) {}
 
}